// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.share {}

.share .share-form-header {
	font-size: 17px;
	color: #0c509b;
	cursor: pointer;
	padding-top: 16px;
	padding-bottom: 16px;
}

.share .share-form {
	padding-bottom: 16px;
}

.share .share-form select {
	width: 100%;
	height: 36px;
	border: solid 1px #999;
	font-size: 14px;
	margin-bottom: 8px;
	border-radius: 5px;
	box-sizing: border-box;
}

.share .share-form input[type=email] {
	width: 100%;
	height: 36px;
	border: solid 1px #999;
	font-size: 14px;
	border-radius: 5px;
	box-sizing: border-box;
	margin-bottom: 8px;
}

.share .share-form .send-request-button {
	width: 100%;
	border: solid 1px #4f638d;
	background: #4f638d;
	color: #FFF;
	height: 36px;
	font-size: 17px;
	line-height: 36px;
	border-radius: 5px;
	padding: 0;
	box-sizing: border-box;
}

.share .share-form .request-status {
	padding-top: 8px;
	font-size: 14px;
}

.share .share-form .request-status.error-message {
	color: #AB1F2B;
}

.share .share-section {
	border-top: solid 1px #ddd;
	padding-bottom: 16px;
	margin-left: 16px;
	margin-right: 16px;
	position: relative;
}

.share .share-section .verify-email-message {
	padding-bottom: 16px;
	font-size: 14px;
}

.share .share-section .share-button {
	border-radius: 5px;
	font-size: 15px;
	padding: 8px 16px;
	cursor: pointer;
	margin-right: 8px;
}

.share .share-section .share-button.accept-button {
	border: solid 1px #4f638d;
	background: #4f638d;
	color: #FFF;
}

.share .share-section .share-button.decline-button {
	border: solid 1px #bbb;
	background: #FFF;
	color: #000;
}

.share .share-section .fa-chevron-right,
.share .share-section .fa-chevron-down {
	position: absolute;
	top: 21px;
	right: 0;
	color: #c7c7cc;
	font-size: 15px;
}

.share .share-section .section-header {
	padding: 16px 0;
	font-size: 15px;
	text-transform: uppercase;
	color: #555;
}

.share .share-section .network-member {
	background: #FFF;
	padding-top: 8px;
	padding-left: 76px;
	position: relative;
	min-height: 76px;
	box-sizing: border-box;
}

.share .share-section .network-member .member-info {
	border-bottom: solid 1px #ececec;
	padding-bottom: 8px;
}

.share .share-section .network-member:last-child .member-info {
	border: none;
}

.share .share-section .network-member.network-member-viewable {
	cursor: pointer;
}

.share .share-section .network-member .share-buttons {
	margin-top: 4px;
	margin-bottom: 4px;
}

.share .share-section .network-member .member-content {}

.share .share-section .network-member .photo {
	position: absolute;
	left: 0;
	top: 8px;
	overflow: hidden;
	height: 60px;
	width: 60px;
	border-radius: 30px;
}

.share .share-section .network-member .photo img {
	height: 60px;
	width: 60px;
}

.share .share-section .network-member .patient-name {
	font-size: 17px;
	font-weight: bold;
}

.share .share-section .network-member .patient-age {
	font-size: 14px;
	color: #555;
}

.share .share-section .network-member .patient-problems {
	font-size: 12px;
	color: #555;
}

.share .share-section .outbound-request {
	padding-top: 8px;
	padding-bottom: 8px;
	padding-right: 90px;
	border-bottom: solid 1px #ececec;
	position: relative;
}

.share .share-section .outbound-request:last-child {
	border-bottom: none;
}

.share .share-section .outbound-request .request-email {
	font-size: 17px;
	font-weight: bold;
}

.share .share-section .outbound-request .request-type {
	font-size: 14px;
	color: #555;
}

.share .share-section .outbound-request .decline-button {
	position: absolute;
	right: 0;
	top: 11px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/Share.css"],"names":[],"mappings":"AAAA,QAAQ;;AAER;CACC,eAAe;CACf,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,eAAe;CACf,kBAAkB;CAClB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,0BAA0B;CAC1B,oBAAoB;CACpB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,WAAW;AACZ;;AAEA;;CAEC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,eAAe;CACf,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;CACC,gCAAgC;CAChC,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA,uDAAuD;;AAEvD;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;CACnB,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;AACV","sourcesContent":[".share {}\n\n.share .share-form-header {\n\tfont-size: 17px;\n\tcolor: #0c509b;\n\tcursor: pointer;\n\tpadding-top: 16px;\n\tpadding-bottom: 16px;\n}\n\n.share .share-form {\n\tpadding-bottom: 16px;\n}\n\n.share .share-form select {\n\twidth: 100%;\n\theight: 36px;\n\tborder: solid 1px #999;\n\tfont-size: 14px;\n\tmargin-bottom: 8px;\n\tborder-radius: 5px;\n\tbox-sizing: border-box;\n}\n\n.share .share-form input[type=email] {\n\twidth: 100%;\n\theight: 36px;\n\tborder: solid 1px #999;\n\tfont-size: 14px;\n\tborder-radius: 5px;\n\tbox-sizing: border-box;\n\tmargin-bottom: 8px;\n}\n\n.share .share-form .send-request-button {\n\twidth: 100%;\n\tborder: solid 1px #4f638d;\n\tbackground: #4f638d;\n\tcolor: #FFF;\n\theight: 36px;\n\tfont-size: 17px;\n\tline-height: 36px;\n\tborder-radius: 5px;\n\tpadding: 0;\n\tbox-sizing: border-box;\n}\n\n.share .share-form .request-status {\n\tpadding-top: 8px;\n\tfont-size: 14px;\n}\n\n.share .share-form .request-status.error-message {\n\tcolor: #AB1F2B;\n}\n\n.share .share-section {\n\tborder-top: solid 1px #ddd;\n\tpadding-bottom: 16px;\n\tmargin-left: 16px;\n\tmargin-right: 16px;\n\tposition: relative;\n}\n\n.share .share-section .verify-email-message {\n\tpadding-bottom: 16px;\n\tfont-size: 14px;\n}\n\n.share .share-section .share-button {\n\tborder-radius: 5px;\n\tfont-size: 15px;\n\tpadding: 8px 16px;\n\tcursor: pointer;\n\tmargin-right: 8px;\n}\n\n.share .share-section .share-button.accept-button {\n\tborder: solid 1px #4f638d;\n\tbackground: #4f638d;\n\tcolor: #FFF;\n}\n\n.share .share-section .share-button.decline-button {\n\tborder: solid 1px #bbb;\n\tbackground: #FFF;\n\tcolor: #000;\n}\n\n.share .share-section .fa-chevron-right,\n.share .share-section .fa-chevron-down {\n\tposition: absolute;\n\ttop: 21px;\n\tright: 0;\n\tcolor: #c7c7cc;\n\tfont-size: 15px;\n}\n\n.share .share-section .section-header {\n\tpadding: 16px 0;\n\tfont-size: 15px;\n\ttext-transform: uppercase;\n\tcolor: #555;\n}\n\n.share .share-section .network-member {\n\tbackground: #FFF;\n\tpadding-top: 8px;\n\tpadding-left: 76px;\n\tposition: relative;\n\tmin-height: 76px;\n\tbox-sizing: border-box;\n}\n\n.share .share-section .network-member .member-info {\n\tborder-bottom: solid 1px #ececec;\n\tpadding-bottom: 8px;\n}\n\n.share .share-section .network-member:last-child .member-info {\n\tborder: none;\n}\n\n.share .share-section .network-member.network-member-viewable {\n\tcursor: pointer;\n}\n\n.share .share-section .network-member .share-buttons {\n\tmargin-top: 4px;\n\tmargin-bottom: 4px;\n}\n\n.share .share-section .network-member .member-content {}\n\n.share .share-section .network-member .photo {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 8px;\n\toverflow: hidden;\n\theight: 60px;\n\twidth: 60px;\n\tborder-radius: 30px;\n}\n\n.share .share-section .network-member .photo img {\n\theight: 60px;\n\twidth: 60px;\n}\n\n.share .share-section .network-member .patient-name {\n\tfont-size: 17px;\n\tfont-weight: bold;\n}\n\n.share .share-section .network-member .patient-age {\n\tfont-size: 14px;\n\tcolor: #555;\n}\n\n.share .share-section .network-member .patient-problems {\n\tfont-size: 12px;\n\tcolor: #555;\n}\n\n.share .share-section .outbound-request {\n\tpadding-top: 8px;\n\tpadding-bottom: 8px;\n\tpadding-right: 90px;\n\tborder-bottom: solid 1px #ececec;\n\tposition: relative;\n}\n\n.share .share-section .outbound-request:last-child {\n\tborder-bottom: none;\n}\n\n.share .share-section .outbound-request .request-email {\n\tfont-size: 17px;\n\tfont-weight: bold;\n}\n\n.share .share-section .outbound-request .request-type {\n\tfont-size: 14px;\n\tcolor: #555;\n}\n\n.share .share-section .outbound-request .decline-button {\n\tposition: absolute;\n\tright: 0;\n\ttop: 11px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
